export const PRODUCT_RELATED_FIELDS = [
	{ key: 'image', label: '', class: 'col-image' },
	{ key: 'sku', label: 'SKU', class: 'col-sku', cellClass: 'td-nowrap' },
	{ key: 'name', label: 'Product name', class: 'col-name' },
	{ key: 'status', label: 'Status', class: 'col-status' },
];
